import HttpRequest from "../../utilities/httpRequest";
import {
  showLoader,
  hideLoader,
  showSnackbar,
} from "../../utilities/UtilitiesActions";
import { getFollowUps, updateFollowUp } from "./FollowUpsActions";

export const getFollowUpsRequest = (data, isHideLoader = false) => {
  let offset = data.page * data.rowsPerPage;
  let limit = data.rowsPerPage;
  const searchData = data.searchData ? JSON.stringify(data.searchData) : "";

  return (dispatch) => {
    if (!isHideLoader) dispatch(showLoader());

    const url = `appointments/list/followUps?limit=${limit}&offset=${offset}&searchData=${searchData}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(getFollowUps({ rows: res.data.rows, count: res.data.count }));
        if (!isHideLoader) dispatch(hideLoader());
        return Promise.resolve(res.data.rows);
      },
      (error) => {
        if (!isHideLoader) dispatch(hideLoader());
        if (error.response?.data?.error)
          dispatch(showSnackbar(error.response.data.error, "error"));
        return Promise.reject(error);
      }
    );
  };
};

/**
 * Every follow-up matching the current filters, for the calendar view.
 *
 * The endpoint is offset-paginated and `searchData` only carries
 * patientName / mobileNumber / status, so there is no way to ask for a date
 * range: the calendar pulls one large page and buckets it by month in the
 * browser. Once the backend accepts fromDate/toDate this should pass the
 * visible month instead of CALENDAR_PAGE_SIZE.
 *
 * Deliberately does not dispatch into the `followUps` store slice — that slice
 * belongs to the paginated table, and overwriting it here would desync the
 * table's page/count.
 */
const CALENDAR_PAGE_SIZE = 500;

export const getFollowUpsForCalendarRequest = (
  searchData,
  isHideLoader = false
) => {
  const search = searchData ? JSON.stringify(searchData) : "";

  return (dispatch) => {
    if (!isHideLoader) dispatch(showLoader());

    const url = `appointments/list/followUps?limit=${CALENDAR_PAGE_SIZE}&offset=0&searchData=${search}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        if (!isHideLoader) dispatch(hideLoader());
        return Promise.resolve(res.data.rows || []);
      },
      (error) => {
        if (!isHideLoader) dispatch(hideLoader());
        if (error.response?.data?.error)
          dispatch(showSnackbar(error.response.data.error, "error"));
        return Promise.reject(error);
      }
    );
  };
};

export const updateFollowUpRequest = (followUpId, payload) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = `appointment/followUp/${followUpId}`;

    return new HttpRequest(dispatch, url, "put", payload).send().then(
      (res) => {
        dispatch(updateFollowUp(res.data.data));
        dispatch(hideLoader());
        dispatch(showSnackbar("Follow-up updated successfully", "success"));
        return Promise.resolve(res.data.data);
      },
      (error) => {
        dispatch(hideLoader());
        if (error.response?.data?.error)
          dispatch(showSnackbar(error.response.data.error, "error"));
        return Promise.reject(error);
      }
    );
  };
};
